import gql from 'graphql-tag';

export const CreateAudioUploadUrl = gql`
    mutation CreateAudioUploadUrl($filename: String!) {
        audioFiles {
            createUploadUrl(filename: $filename) {
                signedUploadUrl
                jwt
            }
        }
    }
`;

export const RegisterAudioUpload = gql`
    mutation RegisterAudioUpload($filename: String!, $jwt: String!) {
        audioFiles {
            registerAudio(filename: $filename, jwt: $jwt) {
                id
                filename
                signedUrl
            }
        }
    }
`;
